import { httpGet, httpGet_New } from './api.service';
import { GetVisitRequest } from '../requestModels/getVisitRequest';
import { Visit } from '../types/Visit';
import { PaginatedResult } from '../types/PaginatedResult';
import { SingleResult } from '../types/SingleResult';
import { Visits } from '../types/Visits';
import { Sighting } from '../types/Sighting';
import { SightingMapResponse } from '../types/SightingFilters';

const getVisit = async (request: GetVisitRequest): Promise<SingleResult<PaginatedResult<Visit>>> => {
  return await httpGet<SingleResult<PaginatedResult<Visit>>>(`api/visit`, request);
};

const getVisits = async (request: GetVisitRequest): Promise<PaginatedResult<Visits>> => {
  return await httpGet<PaginatedResult<Visits>>(`api/visit`, request);
};

const getVisitLog = async (request: any): Promise<PaginatedResult<Visit>> => {
  const res = await httpGet<PaginatedResult<Visit>>(`api/visit/log`, request);
  return { ...res, totalCount: res.totalCount ?? res.count };
};

const getVisitSightings = async (params: Record<string, any>): Promise<PaginatedResult<Sighting>> => {
  return await httpGet_New<PaginatedResult<Sighting>>('api/SightingProcessed', params);
};

const getSightingsMap = async (params: Record<string, any>): Promise<SightingMapResponse> => {
  return await httpGet_New<SightingMapResponse>('api/SightingProcessed/map', { ...params, take: 100 });
};

const getVisitJourney = async (visitId: string): Promise<PaginatedResult<Visit>> => {
  return await httpGet<PaginatedResult<Visit>>(`api/visit/${visitId}/journey`);
};

const getVisitFacilityJourney = async (visitId: string, params?: Record<string, any>): Promise<any> => {
  return await httpGet<any>(`api/visit/${visitId}/facility-journey`, params);
};

export { getVisit, getVisits, getVisitLog, getVisitSightings, getSightingsMap, getVisitJourney, getVisitFacilityJourney };
